module.exports = __webpack_public_path__ + "static/img/friendbtn.4cb0635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/friendbtn.png
// module id = 4ZH+
// module chunks = 1